import React from 'react';
import { useInput } from 'react-admin';
import { Box, TextField } from '@mui/material';

interface DateTimeFilterInputProps {
  source: string;
  label: string;
  defaultTime?: string;
  alwaysOn?: boolean;
}

export const DateTimeFilterInput: React.FC<DateTimeFilterInputProps> = ({
  source,
  label,
  defaultTime = '00:00',
}) => {
  const { field } = useInput({ source });

  const toParts = (value: Date | string | null | undefined) => {
    if (!value) return { date: '', time: defaultTime };
    const d = value instanceof Date ? value : new Date(value);
    if (isNaN(d.getTime())) return { date: '', time: defaultTime };
    const pad = (n: number) => String(n).padStart(2, '0');
    return {
      date: `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`,
      time: `${pad(d.getHours())}:${pad(d.getMinutes())}`,
    };
  };

  const { date, time } = toParts(field.value);

  const emitValue = (newDate: string, newTime: string) => {
    if (!newDate) {
      field.onChange(null);
      return;
    }
    const [y, mo, d] = newDate.split('-').map((s) => parseInt(s, 10));
    const timeStr = newTime || defaultTime;
    const [hStr, miStr] = timeStr.split(':');
    const h = parseInt(hStr, 10) || 0;
    const mi = parseInt(miStr, 10) || 0;
    field.onChange(new Date(y, mo - 1, d, h, mi, 0, 0));
  };

  return (
    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
      <TextField
        type="date"
        label={label}
        value={date}
        onChange={(e) => emitValue(e.target.value, time)}
        InputLabelProps={{ shrink: true }}
        size="small"
        variant="filled"
      />
      <TextField
        type="time"
        value={time}
        onChange={(e) => emitValue(date, e.target.value)}
        InputLabelProps={{ shrink: true }}
        size="small"
        variant="filled"
        sx={{ width: 110 }}
      />
    </Box>
  );
};
